if (!customElements.get('ag-review-form')) customElements.define('ag-review-form', class extends HTMLElement {
  #events;
  connectedCallback() {
    if (this.#events) return;
    this.#events = new AbortController();
    const frame = this.querySelector('iframe');
    let url;
    try { url = new URL(this.dataset.form); } catch { return; }
    if (url.protocol !== 'https:') return;
    url.searchParams.set('embed', 'storefront');
    const params = new URLSearchParams(location.search);
    const fragment = new URLSearchParams(location.hash.slice(1));
    const product = params.get('productId');
    const token = fragment.get('token') || params.get('token');
    if (product) url.searchParams.set('productId', product);
    if (token) url.searchParams.set('token', token);
    window.addEventListener('message', event => {
      if (event.source !== frame.contentWindow || event.origin !== url.origin) return;
      const data = event.data;
      if (data?.type !== 'astrography-review-form-height' || !Number.isFinite(data.height)) return;
      frame.style.height = `${Math.max(400, Math.min(20000, data.height))}px`;
      frame.style.minHeight = '0';
      this.querySelector('[role=status]').hidden = true;
    }, { signal: this.#events.signal, passive: true });
    frame.src = url.href;
    frame.hidden = false;
  }
  disconnectedCallback() { this.#events?.abort(); this.#events = null; }
});
